// hooks/useAxiosWithEnv.ts
import { useEffect } from "react";
import { axiosInstance } from "../utils/axiosInstance";

export const useAxiosWithEnv = (env: string) => {
  useEffect(() => {
    const interceptor = axiosInstance.interceptors.request.use((config) => {
      config.params = {
        env,           // interceptor default
        ...config.params, // explicit params from caller override the default
      };
      return config;
    });

    return () => {
      axiosInstance.interceptors.request.eject(interceptor);
    };
  }, [env]);
};
